<template>
    <div class="task-details-container">
        <task-details-header v-on:passRecruitType="getRecruitType" v-on:viewStatusId="getViewStatus"
                             v-on:passRequirement="getRequirement" v-on:allowOperate="getAllowOperate"></task-details-header>
        <div class="task-requirement-wrapper">
            <span v-if="recruitType===2" class="requirement-label">{{ $t('comb.additionRequirement') }}</span>
            <span v-if="recruitType===1" class="recommend-label">{{ $t('comb.recommendAnchor') }}</span>
            <span v-if="recruitType===2" class="task-requirement" ref="requirement">
                {{ requirement }}
            </span>
        </div>
        <audition-item v-for="anchor in anchors" :imgUrl="getHeadIcon(anchor.logoPic)"
            :anchorName="anchor.nickname" :fansCount="anchor.fansCount" :duration="anchor.candidateDto.duration"
            :auditionDate="anchor.candidateDto.createTime" :description="anchor.candidateDto.comment"
            :audioUrl="anchor.candidateDto.defaultUrl" :waveUrl="anchor.candidateDto.waveForm"
            :status="anchor.candidateDto.offerStatusId" :fileId="anchor.candidateDto.fileId"
            :anchorId="anchor.uid" @sendAudition="sendAudition" :canInvite="canInvite"
            :requirementId="requirementId" :candidateId="anchor.candidateDto.candidateId" :recruitmentType="recruitType"
            :isPlayed="anchor.candidateDto.isPlayed" :offerRejectedReason="anchor.candidateDto.offerRejectedReason"
            :allowOperate="allowOperate" :anchorGrade="anchor.anchorGrade" :anchorType="anchor.verifyType"></audition-item>
        <div class="pagination-block" v-if="total>0">
            <el-pagination
                    @current-change="pageChange"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    layout="prev, pager, next"
                    :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import TaskDetailsHeader from './TaskDetailsHeader.vue';
    import AuditionItem from '../../components/AuditionItem.vue';
    export default{
        components: {
            TaskDetailsHeader,
            AuditionItem
        },
        data(){
            return {
                requirement: '',
                canInvite: true,
                activeName: 'first',
                requirementId: '',
                recruitType: 2,
                currentPage: 1,
                total: 0,
                pageSize: 10,
                anchors: [],
                playedFilter: '',
                allowOperate: false
            };
        },
        methods: {
            getRequirement(requirement) {
                this.requirement = requirement;
            },
            getRecruitType(type) {
                this.recruitType = type;
            },
            getViewStatus(status) {
                if(status === 3) {
                    this.$router.push({name: 'taskDetailsMaking', params: this.requirementId});
                }
            },
            getAllowOperate(value) {
                this.allowOperate = value;
            },
            getAnchors(index) {
                this.anchors = [];
              axios.get(`/api/requirement/${this.requirementId}/candidate/detailList/${index}`).then(res => {
                    if(res.data.code === 200) {
                        if (xm && xm.xmPlayer) {
                            xm.xmPlayer.pause();
                        }
                        this.canInvite = res.data.data.offerCount === 0;
                        this.anchors = res.data.data.pageDto.items;
                        this.currentPage = res.data.data.pageDto.pageNum;
                        this.pageSize = res.data.data.pageDto.pageSize;
                        this.total = res.data.data.pageDto.total;
                        setTimeout(() => {
                            $("[sound_id]").xmPlayer();
                        }, 300);
                    }
                });
            },
            sendAudition() {
                this.canInvite = false;
            },
            getHeadIcon(value) {
                let reg = new RegExp('^http://');
                return value? (reg.test(value)? value:this.$store.state.UPLOAD_IMG_HOST + value)
                    : 'http://s1.xmcdn.com/css/img/common/default/user110.jpg';
            },
            pageChange(index) {
                this.getAnchors(index);
            }
        },
        beforeMount() {
            this.requirementId = this.$route.params.id;
            this.getAnchors(1);
        }
    }
</script>
<style lang="sass">
    @import "../../../sass/copyright/center/task-details-mass.scss";
</style>



// WEBPACK FOOTER //
// TaskDetailsMass.vue?502a7391